import { BundledItem } from '../api/contracts/catalog/bundles';
import { useProductsByIds } from '../api/hooks/product';

export const useBundleProducts = (mainDeviceId: string | undefined, bundledItems: BundledItem[]) => {
  const products = useProductsByIds([...(mainDeviceId ? [mainDeviceId] : []), ...bundledItems.map(item => item.catalogItem)]);

  const mainDevice = products.find(product => product.id === mainDeviceId);
  const mainDeviceCount = bundledItems.find(item => item.catalogItem === mainDeviceId)?.count ?? 1;

  const peripherals = products
    .filter(product => product.id !== mainDeviceId)
    .map(peripheral => {
      const count = bundledItems.find(item => item.catalogItem === peripheral.id)?.count;
      return {
        ...peripheral,
        count: count ?? 1
      };
    });

  return {
    mainDevice: mainDevice ? { ...mainDevice, count: mainDeviceCount } : undefined,
    peripherals
  };
};
